import { render, staticRenderFns } from "./EditarIndumentaria.vue?vue&type=template&id=9b71a314"
import script from "./EditarIndumentaria.vue?vue&type=script&lang=js"
export * from "./EditarIndumentaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports